import { render, staticRenderFns } from "./HomeLogged.vue?vue&type=template&id=10897e49&"
import script from "./HomeLogged.vue?vue&type=script&lang=js&"
export * from "./HomeLogged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports